import { Fragment } from "react";
import "./Button.css";

export default function CommonButton({
  onClick,
  label,
  to,
  icon,
  variant,
  disabled,
  fontSize,
}) {
  const handleClick = () => {
    if (!disabled) {
      // Check if the button is disabled before handling the click
      if (onClick) {
        onClick();
      }
      if (to) {
        window.location.href = to;
      }
    }
  };

  // Define CSS class based on the variant prop
  let buttonClass;
  if (variant === "primary") {
    buttonClass = "primaryButton";
  } else if (variant === "variant1") {
    buttonClass = "variant1";
  } else if (variant === "variant2") {
    buttonClass = "variant2";
  } else if (variant === "variant3") {
    buttonClass = "variant3";
  } else if (variant === "variant4") {
    buttonClass = "variant4";
  } else if (variant === "variant5") {
    buttonClass = "variant5";
  } else if (variant === "variant6") {
    buttonClass = "variant6";
  } else if (variant === "variant7") {
    buttonClass = "variant7";
  } else if (variant === "variant8") {
    buttonClass = "variant8";
  } else if (variant === "primary2") {
    buttonClass = "primary2";
  } else if (variant === "primary3") {
    buttonClass = "primary3";
  } else if (variant === "primary4") {
    buttonClass = "primary4";
  } else {
    buttonClass = "";
  }

  return (
    <Fragment>
      <div
        className={`submitButton ${buttonClass} ${disabled ? "disabled" : ""}`}
        onClick={handleClick}
      >
        <img src={icon} alt="" />
        <div className="text" style={{ fontSize: fontSize }}>
          {label}
        </div>
      </div>
    </Fragment>
  );
}
